import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { NON_CONFORMANCE_REPORTS_LOCAL_API_REQUESTS } from './utils/constants';

// GET business/{businessId}/non-conformance-reports/unprocessed-counts
// -> { businessId, total, projects: [{ id, projectKey, name, count, bySubType }] }
// `projects` only includes projects with count > 0, sorted by count desc.
export const getBusinessUnprocessedNcCounts = async (businessId) => {
  const apiPath = `business/${businessId}/non-conformance-reports/unprocessed-counts`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: NON_CONFORMANCE_REPORTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
